<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>视频课程</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" class="user-search">

      <el-form-item label="分类">
        <el-select size="small" v-model="type1" @change="selectOption1()" placeholder="请选择">
          <el-option v-for="type in typeArr1" :label="type.title" :value="type.id" :key="type.id"></el-option>
        </el-select>
      </el-form-item>





      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search"
          @click="getCourseClassifyList(this.type3)">查询</el-button>
      </el-form-item>

      <el-form-item label="">

        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中"
      style="width: 100%;">
      <el-table-column align="center" type="selection" width="60">
      </el-table-column>

      <el-table-column sortable prop="title" label="标题" width="200">
      </el-table-column>

      <el-table-column sortable prop="introduce" label="介绍" width="200">
      </el-table-column>
      <el-table-column sortable prop="price" label="价格" width="200">
      </el-table-column>

      <el-table-column prop="name" label="课程封面" width="150">
        <template slot-scope="scope">
          <img class="tech-img" style="width: 120px; height: 68px;" :src="scope.row.coverPlan">
        </template>
      </el-table-column>



      <el-table-column sortable prop="createTime" label="创建时间" width="150">
        <template slot-scope="scope">
          <div>{{ transformDate(scope.row.createTime) }}</div>
        </template>
      </el-table-column>


      <el-table-column align="center" label="操作" min-width="300">
        <template slot-scope="scope">


          <el-button size="mini" @click="handleEditIsData(scope.$index, scope.row)">资料管理</el-button>
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="deleteCourse(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @click="closeDialog">
      <el-form label-width="120px" ref="editForm">
        <el-form-item label="标题" prop="deptName">
          <el-input size="small" v-model="formData.title" auto-complete="off" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="介绍" prop="deptName">
          <el-input size="small" v-model="formData.introduce" auto-complete="off" placeholder="请输入"></el-input>
        </el-form-item>

        <el-form-item label="价格" prop="deptName">
          <el-input size="small" v-model="formData.price" auto-complete="off" placeholder="请输入"></el-input>
        </el-form-item>


        <el-form-item label="封面图" style="">

          <div class="upload-demo">
            <el-upload action="" :http-request="mainImgUpload" :show-file-list="false" list-type="picture-card">
              <i class="el-icon-plus"></i>
            </el-upload>
            <img v-if="formData.coverPlan" :src="formData.coverPlan" class="avatar">
          </div>
          <el-progress v-if="mainProgress.show" :percentage="mainProgress.percent" style="margin-top: 10px; width: 148px;"></el-progress>

        </el-form-item>




      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="addCourse()"
          v-if="title == '添加'">添加</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="upCourse()"
          v-if="title == '修改'">修改</el-button>
      </div>
    </el-dialog>










    <el-dialog title="资料管理" :visible.sync="isData" width="50%" :close-on-click-modal="false" @click='closeDialog("edit")'>
      <el-table size="small" :data="courseDataList" highlight-current-row v-loading="loading" title="" border
        element-loading-text="拼命加载中" style="width: 100%;">

        <el-table-column prop="id" label="id" width="60"></el-table-column>
        <el-table-column prop="name" label="资料名称" width="200"></el-table-column>

        <el-table-column prop="name" label="封面图" width="120">

          <template slot-scope="scope">
            <img style="width: 90px;height: 90px;" :src="scope.row.coverPlan">
          </template>

        </el-table-column>


        <el-table-column prop="createTime" label="创建时间" width="200">
          <template slot-scope="scope">
            <div>{{ transformDate(scope.row.createTime) }}</div>
          </template>
        </el-table-column>
        <!-- <el-table-column sortable prop="editUser" label="修改人" width="300">
         </el-table-column> -->
        <el-table-column align="center" label="操作" min-width="300">
          <template slot-scope="scope">
            <el-button size="mini" type="success" @click="editFormVisibleCourseDataModifyhandleEdit(scope.row)">修改</el-button>
            <el-button size="mini" type="danger" @click='deleteFileCourseData(scope.row)'>删除</el-button>
            <el-button size="mini" type="success" @click="openFile(scope.row.dataUrl)">下载</el-button>

            
          </template>
        </el-table-column>
      </el-table>
      <el-form :inline="true" :model="formInline">


        <el-form-item>




          <!-- <el-upload class="upload-demo" :action="accessoryAction" :on-preview="handlePreview" :on-remove="handleRemove"
              :before-remove="beforeRemove" multiple :limit="3" :on-exceed="handleExceed" :on-success="accessoryfileSuccess"
              :on-change="accessoryfileChange" :file-list="fileList">
  
              <el-button size="small" type="primary" icon="el-icon-upload2">上传</el-button>
  
  
            </el-upload> -->

          <el-button size="small" type="primary" class="title" @click="handleEditFormVisibleCourseData">添加</el-button>

        </el-form-item>




      </el-form>
    </el-dialog>







    <!-- 编辑界面 -->
    <el-dialog title="添加资料" :visible.sync="editFormVisibleCourseData" width="30%" @click="closeDialog">
      <el-form label-width="120px" ref="editForm">
        <el-form-item label="名称" prop="deptName">
          <el-input size="small" v-model="courseData.name" auto-complete="off" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="deptName">
          <el-input size="small" v-model="courseData.sort" auto-complete="off" placeholder="请输入"></el-input>
        </el-form-item>

        <el-form-item label="封面图" style="">
          <div class="upload-demo">
            <el-upload action="" :http-request="mainImgUpload1" :show-file-list="false" list-type="picture-card">
              <i class="el-icon-plus"></i>
            </el-upload>
            <img v-if="courseData.coverPlan" :src="courseData.coverPlan" class="avatar">
          </div>
          <el-progress v-if="courseProgress.show" :percentage="courseProgress.percent" style="margin-top: 10px; width: 148px;"></el-progress>
        </el-form-item>

        <el-form-item label="上传文件" style="">
          <el-upload class="upload-demo" :http-request="testTx" :show-file-list="false">
            <el-button size="small" type="primary" icon="el-icon-upload2">点击上传</el-button>
          </el-upload>
          <el-progress v-if="fileProgress.show" :percentage="fileProgress.percent" style="margin-top: 10px;"></el-progress>
        </el-form-item>
        <el-form-item label="上传状态" style="">

          <!-- <el-button size="small" type="primary" >
              </el-button> -->
          <a :href="courseData.dataUrl">查看{{ courseData.dataUrl }}</a>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <!-- <el-button size="small" @click="closeDialog">取消</el-button> -->
        <el-button size="small" type="primary" :loading="loading" class="title" @click="addCourseData()">添加</el-button>
      </div>
    </el-dialog>



    <!-- 编辑界面 -->
    <el-dialog title="修改资料" :visible.sync="editFormVisibleCourseDataModify" width="30%" @click="closeDialog">
      <el-form label-width="120px" ref="editForm">
        <el-form-item label="名称" prop="deptName">
          <el-input size="small" v-model="courseData.name" auto-complete="off" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="deptName">
          <el-input size="small" v-model="courseData.sort" auto-complete="off" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="封面图" style="">
          <div class="upload-demo">
            <el-upload action="" :http-request="mainImgUpload1" :show-file-list="false" list-type="picture-card">
              <i class="el-icon-plus"></i>
            </el-upload>
            <img v-if="courseData.coverPlan" :src="courseData.coverPlan" class="avatar">
          </div>
          <el-progress v-if="courseProgress.show" :percentage="courseProgress.percent" style="margin-top: 10px; width: 148px;"></el-progress>
        </el-form-item>

        <el-form-item label="上传文件" style="">
          <el-upload class="upload-demo" :http-request="testTx" :show-file-list="false">
            <el-button size="small" type="primary" icon="el-icon-upload2">点击上传</el-button>
          </el-upload>
          <el-progress v-if="fileProgress.show" :percentage="fileProgress.percent" style="margin-top: 10px;"></el-progress>
        </el-form-item>
        <el-form-item label="上传状态" style="">

          <!-- <el-button size="small" type="primary" >
              </el-button> -->
          <a :href="courseData.dataUrl">查看{{ courseData.dataUrl }}</a>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <!-- <el-button size="small" @click="closeDialog">取消</el-button> -->
        <el-button size="small" type="primary" :loading="loading" class="title" @click="upCourseData()">修改</el-button>
      </div>
    </el-dialog>


  </div>
</template>
  
<script>
import {



  getCourseClassifyList,


  addCourseData,
  upCourseData,
  deleteCourseData,
  getCourseClassifyDataList,
  getCourseDataList,

  addCourse,
  upCourse,
  deleteCourse,
  getCourseList,

  getSignatureVue


} from "../../api/userMG";
import Pagination from "../../components/Pagination";
import client from "@/utils/ossClient.js";

import TcVod from 'vod-js-sdk-v6'
export default {
  data() {
    return {


      isData: false,






      type1: 0,
      typeArr1: [],




      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: "添加",

      listData: [], //
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 20,
        total: 10,
      },


      formData: {
        coverPlan: "",//封面图
        title: "",//标题     
        introduce: "",//介绍   
        difficultyLevel: "",//难度等级   
        superiorId: 0,//上级ID   
        level: 0,//分类等级     
        type: 2,// 0课程分类，1直播分类，2vip分类  
        titleOne: "",//二级标题     
        introduceOne: "",//二级介绍  
        price: ""//价格 

      },

      courseDataList: [],//课程资料
      editFormVisibleCourseData: false, //控制编辑页面显示与隐藏
      editFormVisibleCourseDataModify: false, //控制编辑页面显示与隐藏
      courseData: {
        name: "",//名称
        coverPlan: "",//封面图     
        courseClassifyId: "",//课程分类资料ID
        courseId: 0,//资料ID
        type: "",// 资料类型      
        superiorId: "",//  
      },
      mainProgress: { show: false, percent: 0 },
      courseProgress: { show: false, percent: 0 },
      fileProgress: { show: false, percent: 0 },
    };
  },
  // 注册组件
  components: {
    Pagination,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {


    this.getSuperiorCourseClassifyList(0, 0)

  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {

    openFile(fileName) {
      window.open(fileName);
    },


    testTx(file) {

      var self = this;
      // 通过 import 引入的话，new TcVod(opts) 即可
      // new TcVod.default(opts) 是 script 引入 的用法
      const tcVod = new TcVod({
        getSignature: this.getSignature

      })



      var fileName = file.file.name;
      var fileType = file.file.type;


      this.courseData.name = fileName




      if (fileType.indexOf("video") != -1) {
        //视频
        this.courseData.type = 0

      }

      if (fileType.indexOf("application") != -1) {
        //ppt
        this.courseData.type = 1


      }

      if (fileType.indexOf("image") != -1) {
        //照片
        this.courseData.type = 2

      }


      if (this.courseData.type != 0) {

        //判断扩展名
        const tmpcnt = file.file.name.lastIndexOf(".");
        const exname = file.file.name.substring(tmpcnt + 1);
        const fileName = file.file.uid + "." + exname;
        
        this.fileProgress.show = true;
        this.fileProgress.percent = 0;
        
        client
          .put(fileName, file.file, {
            progress: (p) => {
              this.fileProgress.percent = Math.round(p * 100);
            }
          })
          .then((res) => {
            console.log("1111111111", res)
            self.courseData.dataUrl = res.url;
            self.courseData = JSON.parse(JSON.stringify(self.courseData))
            setTimeout(() => { this.fileProgress.show = false; }, 1000);
          })
          .catch((err) => {
            console.log("2222222222", err)
            this.fileProgress.show = false;
          });


        return;
      }

      this.fileProgress.show = true;
      this.fileProgress.percent = 0;

      const uploader = tcVod.upload({
        mediaFile: file.file, // 媒体文件（视频或音频或图片），类型为 File
      })
      uploader.on('media_progress', function (info) {
        console.log("进度") // 进度
        console.log(info) // 进度
        self.fileProgress.percent = Math.round(info.percent * 100);
      })


      // 回调结果说明
      uploader.done().then(function (doneResult) {
        // deal with doneResult
        console.log("doneResult") // 进度
        console.log(doneResult) // 进度


        self.courseData.fileId = doneResult.fileId;
        self.courseData.dataUrl = doneResult.video.url;


        self.courseData = JSON.parse(JSON.stringify(self.courseData))
        setTimeout(() => { self.fileProgress.show = false; }, 1000);


      }).catch(function (err) {
        // deal with error
        console.log("err") // 进度
        console.log(err) // 进度
        self.fileProgress.show = false;
      })




    },


    getSignature() {


      // return "hLYFcsZG4esjzjzqPVfHDsSK6s9zZWNyZXRJZD1BS0lEOUE1b0lhZ1lWRnZPZWdUMk5WUjljcnRnR2h2dWtMaXEmY3VycmVudFRpbWVTdGFtcD0xNzAyMjMwOTYzJmV4cGlyZVRpbWU9MTcyMjIzMDk2MyZyYW5kb209MTcwMjIzMDk2Mw==";







      return getSignatureVue().then((res) => {

        console.log("调用签名", res.data.signature) // 进度
        return res.data.signature;
      });


      //       return axios.post("http://smxz.natapp1.cc/app-yijiu-backstage/getSignature").then(function (response) {

      // console.log("调用签名",response) // 进度

      // return response.data.signature;
      // })







    },

    selectOption1() {


      this.getCourseList()

    },


    // 按等级获取数据
    getSuperiorCourseClassifyList() {
      this.loading = true;

      getCourseClassifyList({ type: 0, superiorId: 0 }).then((res) => {
        this.loading = false;
        if (res.code == 200) {
          this.listData = []
          //选择的第一级
          this.typeArr1 = res.data.list;
          this.type1 = this.typeArr1[0].id;


          this.getCourseList()

        } else {




        }

      });
    },









    // 删除
    deleteCourse(index, row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteCourse({ id: row.id })
            .then((res) => {
              if (res.code == 200) {
                this.$message({
                  type: "success",
                  message: "已删除！",
                });
                this.getCourseList(this.type1);
              } else {
                this.$message({
                  type: "info",
                  message: res.msg,
                });
              }
            })
            .catch((err) => {
              this.loading = false;
              this.$message.error("删除失败，请稍后再试！");
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    //修改
    upCourse() {

      this.loading = true;
      this.formData.classifyId = this.type1;
      this.formData.type = 0;


      var formData = JSON.parse(JSON.stringify(this.formData));


      upCourse(formData).then((res) => {
        this.loading = false;
        if (res.code == 200) {
          this.editFormVisible = false
          this.$message({
            type: "success",
            message: res.msg,
          });
          this.getCourseList(this.type1);
        } else {
          this.$message.error(res.msg);
        }
      });
    },

    //添加
    addCourse() {

      this.loading = true;

      var formData = JSON.parse(JSON.stringify(this.formData))


      addCourse(this.formData).then((res) => {
        this.loading = false;
        if (res.code == 200) {
          this.editFormVisible = false
          this.$message({
            type: "success",
            message: res.msg,
          });
          this.getCourseList(this.type1);
        } else {
          this.$message.error(res.msg);
        }
      });
    },

    // 删除
    deleteFileCourseData(row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteCourseData({ id: row.id })
            .then((res) => {
              if (res.code == 200) {
                this.$message({
                  type: "success",
                  message: "已删除！",
                });
                this.getCourseClassifyDataList(row.courseId)
              } else {
                this.$message({
                  type: "info",
                  message: res.msg,
                });
              }
            })
            .catch((err) => {
              this.loading = false;
              this.$message.error("删除失败，请稍后再试！");
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },


    //添加课程资料
    addCourseData() {


      var formData = JSON.parse(JSON.stringify(this.courseData))




      addCourseData(formData).then((res) => {
        this.loading = false;
        if (res.code == 200) {
          this.editFormVisibleCourseData = false
          this.$message({
            type: "success",
            message: res.msg,
          });
          this.courseData.name = "";
          this.getCourseClassifyDataList(this.courseData.courseId)
        } else {
          this.$message.error(res.msg);
        }
      });
    },



    //修改课程资料
    upCourseData() {

      this.courseData.courseClassifyId = 0; 
      console.log(this.courseData)
      var formData = JSON.parse(JSON.stringify(this.courseData))

      upCourseData(formData).then((res) => {
        this.loading = false;
        if (res.code == 200) {
          this.editFormVisibleCourseDataModify = false
          this.$message({
            type: "success",
            message: res.msg,
          });
          this.courseData.id = "";
          this.courseData.dataUrl = "";
          this.courseData.coverPlan = "";
          this.courseData.name = "";
          this.getCourseClassifyDataList(this.courseData.courseId)
        } else {
          this.$message.error(res.msg);
        }
      });
    },


    

    //自定义上传方法..
    mainImgUpload(file) {

      //判断扩展名
      const tmpcnt = file.file.name.lastIndexOf(".");
      const exname = file.file.name.substring(tmpcnt + 1);
      const fileName = file.file.uid + "." + exname;
      
      this.mainProgress.show = true;
      this.mainProgress.percent = 0;
      
      client
        .put(fileName, file.file, {
          progress: (p) => {
            this.mainProgress.percent = Math.round(p * 100);
          }
        })
        .then((res) => {
          if (res.url) {
            this.formData.coverPlan = res.url;
            setTimeout(() => { this.mainProgress.show = false; }, 1000);
          } else {
            this.$message.error("文件上传失败");
            this.mainProgress.show = false;
          }
        })
        .catch((err) => { 
          this.mainProgress.show = false;
        });
    },

    //自定义上传方法..
    mainImgUpload1(file) {

      //判断扩展名
      const tmpcnt = file.file.name.lastIndexOf(".");
      const exname = file.file.name.substring(tmpcnt + 1);
      const fileName = file.file.uid + "." + exname;
      
      this.courseProgress.show = true;
      this.courseProgress.percent = 0;
      
      client
        .put(fileName, file.file, {
          progress: (p) => {
            this.courseProgress.percent = Math.round(p * 100);
          }
        })
        .then((res) => {
          if (res.url) {
            this.courseData.coverPlan = res.url;
            setTimeout(() => { this.courseProgress.show = false; }, 1000);
          } else {
            this.$message.error("文件上传失败");
            this.courseProgress.show = false;
          }
        })
        .catch((err) => { 
          this.courseProgress.show = false;
        });
    },


    // 获取
    getCourseList() {
      this.loading = true;

      getCourseList({ type: 0, classifyId: this.type1 }).then((res) => {
        this.loading = false;
        if (res.code == 200) {
          this.listData = res.data.list;
          return;
        }
        this.$message({
          type: "info",
          message: res.msg,
        });
      });
    },





    


    //显示编辑界面
    handleEditFormVisibleCourseData: function () {

      this.courseData.id = "";
          this.courseData.dataUrl = "";
          this.courseData.coverPlan = "";
          this.courseData.name = "";
      this.editFormVisibleCourseData = true;

   
    },
    //显示编辑界面
    handleEditIsData: function (index, row) {
      this.isData = true;
      this.courseData.courseId = row.id;


      this.getCourseClassifyDataList(row.id)
    },
    // 获取资料数据列表
    getCourseClassifyDataList(courseId) {
      this.loading = true;

      getCourseDataList({ superiorId: 0, courseId: courseId }).then((res) => {
        this.loading = false;
        if (res.code == 200) {
          this.courseDataList = res.data.list;
          return;
        }
        this.$message({
          type: "info",
          message: res.msg,
        });
      });
    },









    // 分页插件事件
    callFather(parm) {
      this.getDishesList(parm.currentPage);
    },

    //显示编辑界面
    handleEdit: function (index, row) {
      this.editFormVisible = true;
      if (row != undefined && row != "undefined") {
        this.title = "修改";
        this.formData.id = row.id;
        this.formData.coverPlan = row.coverPlan;
        this.formData.introduce = row.introduce;
        this.formData.title = row.title;
        this.formData.introduceOne = row.introduceOne;
        this.formData.titleOne = row.titleOne;
        this.formData.difficultyLevel = row.difficultyLevel;

        this.formData.price = row.price;



      } else {
        this.title = "添加";
        this.formData.id = "";
        this.formData.coverPlan = "";
        this.formData.introduce = "";
        this.formData.title = "";
        this.formData.introduceOne = "";
        this.formData.titleOne = "";
        this.formData.difficultyLevel = 1;
        this.formData.classifyId = this.type1;
        this.formData.type = 0;
        this.formData.price = "";






      }
    },

    //显示编辑界面
    editFormVisibleCourseDataModifyhandleEdit: function ( row) {
      console.log("123",row)
      if (row != undefined && row != "undefined") {

        this.courseData = row;
      
        this.editFormVisibleCourseDataModify = true;
        
        
        


      } else {
 






      }
    },

    

    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false;
    },
  },
};
</script>
  
<style scoped>
.user-search {
  margin-top: 20px;
}

.userRole {
  width: 100%;
}

.upload-demo {
  display: flex;
  flex-direction: row;
}

.upload-demo img {
  width: 140px;
  height: 140px;
}
</style>
  
   
   


// WEBPACK FOOTER //
// src/views/videoCourse/VideoCourse.vue